import * as React from 'react';

class CustomerInformationComponent extends React.Component {

  render() {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="bold-title">
                Información Básica para el cliente
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Información Básica para el cliente
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  1.-
                </span>
                Funcionamientos
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>La plataforma de inversión de TCA tendrá secciones dedicadas a emprendedores y a inversores.</p>
              <div className="gap-20"/>
              <h5>a&#41; Sección Inversores</h5>

              <p>Las oportunidades de inversión existentes en la plataforma aparecerán en la sección “Operaciones para
                Invertir”, con una breve descripción de la cantidad de inversión solicitada, el plazo restante para
                invertir, y las estadísticas relativas al estado del proceso de recogida de muestras de interés (“Me
                interesa”) y compromisos de inversión (“Invertir”) por parte de los usuarios.</p>

              <p>El usuario inversor (usuario registrado con la finalidad de invertir en las operaciones ofertadas en la
                plataforma) que podrá acceder a la información disponible para llevar a cabo el análisis de la compañía
                y acceder a las novedades o informaciones que se publiquen seleccionando el apartado “Me interesa”
                correspondiente, lo cual le facultará además para participar en un foro con el equipo emprendedor, en
                todo o en parte, de la compañía objeto de la potencial inversión. Se podrá deseleccionar el seguimiento
                en cualquier momento, sin ningún tipo de limitación. La selección “Me interesa” no compromete a nada,
                pero las informaciones a las que se accederá estarán en todo caso sujetas a la obligación de
                confidencialidad recogida en estos términos y condiciones.</p>

              <p>Los partners podrán organizar, si así lo estiman oportuno, para cada inversión potencial una reunión
                presencial u online en forma de foro entre aquellos usuarios inversores que hayan seleccionado para
                seguimiento (“Me interesa”) una oportunidad de inversión y que deseen acudir y todo o parte del equipo
                emprendedor. En dicho foro, los usuarios inversores podrán evaluar todas las dudas y consultas que
                puedan tener en relación a la inversión proyectada y las actividades de la compañía objeto de la
                potencial inversión. Solo podrán optar a atender al foro presencial, en los casos en que se celebren,
                los usuarios asociados al partner que organice el foro y aquellos invitados de éste que, a su libre
                discreción, determine dicho partner.</p>

              <p>En el caso que el usuario inversor desee comprometer una inversión determinada en una sociedad
                concreta, seleccionará el apartado “Invertir”, y en caso de aceptar el aviso que aparecerá tras realizar
                dicha selección, el inversor se compromete de forma vinculante a llevar a cabo la inversión en el
                importe indicado en el caso que se den las condiciones indicadas para cada inversión potencial. Este
                compromiso tendrá el carácter de irrevocable. A partir de este momento una vez se haya completado la
                ronda prevista con las cantidades comprometidas por los distintos usuarios inversores, se le solicitará
                al usuario que firme digitalmente (o por otro medio acordado con TCA) en muestra de su consentimiento,
                los términos de la inversión, incluyendo el pacto de socios que regirá la relación entre el inversor y
                la participada y sus socios y el acuerdo de sindicación que deberá suscribir por medio que habrá sido
                aceptado en el momento de seleccionar “Invertir”.</p>

              <p>En el momento de seleccionar “Invertir” se le preguntará si desea invertir a través de
                una sociedad y si desea formar parte del órgano de administración de la entidad en la que
                se invertirá o si desea votar para dicho cargo a otro usuario que desee acceder a dicho cargo
                , en el caso que exista la posibilidad. En el caso que haya más inversores interesados en
                formar parte del Consejo de Administración con vocalías disponibles, se elegirá al representante
                o representantes por orden de la cuantía de la inversión realizada por cada usuario inversor,
                de mayor a menor. A los efectos de calcular la cuantía, se sumará a la cuantía de cada inversor
                candidato la cuantía de aquellos inversores que le hubieren votado.</p>

              <p>En relación a la realización de la inversión por medio de una sociedad, en todo caso el compromiso de
                inversión lo adquirirá, en su caso, personalmente el usuario inversor que seleccione la opción
                “Invertir”, más allá de que exprese su interés en llevarla a cabo por medio de una sociedad bajo su
                control.</p>

              <p>La efectiva ejecución de la inversión estará sujeta en todo caso a la obtención de compromisos de
                inversión por el importe mínimo indicado para cada inversión en la información relativa a la misma. En
                caso de no alcanzar el importe mínimo indicado, los usuarios tendrán derecho a que les sean reintegrada
                la cantidad invertida.</p>

              <p>Los usuarios inversores deben conocer que en el momento en que seleccionen la opción “Me interesa” y en
                el momento en que seleccionen la opción “Invertir”, en su caso, en relación a cualquier inversión
                concreta, el equipo del emprendedor de la sociedad objetivo de la inversión, podrá tener conocimiento de
                ello a través de la plataforma y de la identidad de los usuarios inversores que expresen su interés
                seleccionando “Me interesa” y/o su compromiso de inversión seleccionando la opción “Invertir”.</p>

              <h4>b&#41; Sección emprendedores:</h4>

              <p>Mediante esta sección los usuarios emprendedores (usuario registrado con la finalidad de obtener
                financiación de una operación propia publicada en la plataforma para obtener financiación por parte
                de los usuarios inversores) podrán presentar operaciones a la consideración de TCA (en los términos
                recogidos en la propia plataforma) y que serán indicados al usuario en el propio proceso de
                presentación de la solicitud de inversión.</p>

              <p>TCA discutirá y acordará, en su caso, los términos completos de la inversión solicitada por el
                emprendedor que hubiere presentado su operación empresarial a consideración, a partir de cuyo momento
                dicha inversión potencial acordada pasará a aparecer como una oportunidad de inversión en el apartado
                “Invertir” de la sección “Inversores”.</p>

              <p>A través de la plataforma, los usuarios emprendedores podrán dar seguimiento en tiempo real a las
                muestras de interés y los compromisos de inversión de los usuarios inversores.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  2.-
                </span>
                Sindicación
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los usuarios inversores que hayan comprometido una inversión en una sociedad, una vez hayan adquirido
                sus participaciones objeto de la inversión, suscribirán un contrato de sindicación de dichas
                participaciones con los demás usuarios inversores con el objeto de regular, para dicha inversión, la
                relación de los socios en tanto que titulares de las participaciones en la sociedad objeto de la
                inversión y la gestión de las mismas.</p>
              <p>Tanto este acuerdo de sindicación como el contrato de inversión y acuerdo entre socios que se
                suscribirá con la sociedad en que se produzca la inversión, podrán ser visualizados para su análisis por
                parte de los usuarios inversores con carácter previo a su formalización y firma, junto al icono de
                “Invertir”.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  3.-
                </span>
                Formalización y ejecución de las inversiones
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Cualquier usuario emprendedor que someta una operación a la consideración de TCA, manifiesta y
                garantiza que tiene poder suficiente y el consentimiento y autorización de los socios que fuera
                necesario para la publicación de oportunidades de inversión e implicará la obligación para dicho
                usuario emprendedor de formalizar dichas autorizaciones en la forma que estime conveniente para
                asegurar el cumplimiento por parte de la operación presentada y sus socios de las
                obligaciones que asuma en el momento de presentación de la operación.</p>

              <p>Toda inversión publicada en la plataforma así como la actividad de los usuarios en la misma se
                formalizará documentalmente de forma íntegra mediante firma digital a través de la plataforma Signaturit
                (salvo acuerdo en contrario con TCA), e incluirá:</p>

              <ul>
                <li>La formalización del compromiso de inversión a través de la suscripción del contrato de inversión y
                  acuerdo de socios.
                </li>
                <li>La formalización del contrato de sindicación que sindicará a los usuarios inversores.</li>
                <li>El ejercicio del derecho de voto que otorgue el contrato de sindicación de participaciones
                  mencionado.
                </li>
              </ul>

              <p>TCA no ofrece como servicio la canalización del capital que los inversores invertirán en la sociedad.
                Dicho servicio de canalización del capital se contrata a la entidad de pagos Mangopay (
                <a
                  href="https://www.mangopay.com/terms/MANGOPAY_Terms-ES.pdf"
                  title="Condiciones de uso de Mangopay"
                  target="_blank"
                >
                  Condiciones de uso de Mangopay
                </a>).
              </p>

              <p>En el momento en que se hayan obtenido los compromisos de inversión necesarios para alcanzar el 75% de
                la inversión, TCA lo comunicará a la sociedad y le remitirá un listado de solicitud de información para
                la realización de la Due Diligence. La sociedad deberá presentar toda la documentación necesaria para la
                realización de la Due Diligence, en sus aspectos legales, fiscales y financieros, así como cualquier
                otra información que sea necesaria para poder validar el estado de la misma y proceder a la elaboración
                del Informe de Due Diligence.</p>

              <p>Una vez remitida por la sociedad toda la información solicitada a estos efectos, TCA, mediante una
                tercera empresa perteneciente al sector legal y habilitada al efecto, cuyo coste asumirá la propia
                sociedad, tendrá un plazo de quince (15) días para la realización del Informe de Due Diligence. En todo
                caso, la variación en el plazo de entrega del Informe estará sometida al cumplimento de entrega por
                parte de la compañía de la documentación requerida.</p>

              <p>Una vez realizado el informe de Due Diligence, el mismo será remitido por TCA a los inversores, quienes
                dispondrán de un plazo de tres (3) días, para verificar el estado de la sociedad de conformidad con el
                informe de remitido y, en su caso, confirmar la inversión comprometida.</p>

              <p>En caso que el resultado de la Due Diligence sea favorable, TCA sube a la plataforma los contratos a
                firmar en relación a la inversión (Contrato de sindicación y contrato de inversión y pacto de socios).
                Los usuarios inversores tienen un plazo de 5 días en los que revisar los contratos, firmarlos y
                enviarlos de vuelta. Los contratos se firmarán digitalmente mediante la herramienta Signaturit. Una vez
                confirmados los compromisos de inversión, y suscritos los contratos detallados en el plazo anterior, los
                inversores, previa solicitud de TCA, procederán a realizar las transferencias bancarias en la cuantía
                comprometida a TCA, más la cantidad correspondiente al corretaje, en el número de cuenta (o wallet)
                designado al efecto, salvo que se produzca una retirada de la inversión por parte de alguno de los
                inversores, en cuyo caso deberá abonar la cantidad del 10% del compromiso, hasta un máximo de 1.000.-€,
                en concepto de penalización. Una vez recibido el importe total comprometido por los inversores, TCA
                procederá a realizar una única transferencia a la sociedad por el importe total desembolsado, a través
                de la entidad de pagos Mangopay.</p>

              <p>La sociedad se compromete a custodiar con la debida diligencia el importe total desembolsado por TCA en
                concepto de ampliación de capital de la sociedad, y a no hacer disposición del mismo hasta la
                inscripción en el Registro Mercantil correspondiente de la escritura en que se eleve a público el
                referido acuerdo de ampliación de capital de la sociedad. A los efectos oportunos, la sociedad
                suscribirá con TCA, en el momento de recibir los desembolsos, un documento en el que se detallará el
                presente compromiso.</p>

              <p>La inversión se llevará a cabo mediante la adquisición de las participaciones sociales de la sociedad,
                mediante la ampliación de capital por parte de los inversores de TCA que se hayan comprometido a
                invertir, en régimen de sindicación de la totalidad de participaciones sociales adquiridas.</p>

              <p>Acto seguido, la sociedad se compromete a elevar a público el acuerdo de ampliación de capital en un
                plazo que no podrá ser superior a diez (10) días naturales desde la fecha de la transferencia efectuada
                por TCA, mediante la entidad de pagos Mangopay, S.A., por el importe total de la inversión en la cuenta
                bancaria de la sociedad. TCA, subirá la escritura de la ampliación de capital a la plataforma para que
                todos los inversores tengan una copia.</p>

              <p>En el caso de que el resultado de la Due Diligence no fuera satisfactorio, los inversores tendrán
                derecho a no llevar a cabo la inversión y cancelar la ampliación de capital.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  4.-
                </span>
                Reflejo de operaciones
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Cualquier operación de muestra de interés, compromiso o ejecución de inversión que lleve a cabo un
                usuario usando la plataforma de TCA en el sitio web, se confirmará con un aviso en pantalla, y la nueva
                posición quedará reflejada en la información de su cuenta. En caso de discrepancia entre los datos
                reflejados en este apartado de la cuenta de los usuarios y la realidad de las operaciones ejecutadas, el
                usuario podrá informar de ello al departamento técnico de TCA para su debida rectificación y en ningún
                caso podrá interpretarse como el nacimiento o reconocimiento de un derecho, facultad u obligación del
                usuario afectado.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  5.-
                </span>
                Obligaciones de los usuarios inversores
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los usuarios inversores se obligan a:</p>

              <ul>
                <li>Guardar secreto y confidencialidad sobre cualquier información relativa a las sociedades objeto de
                  las oportunidades de inversión, a las propias inversiones o los términos planteados para la misma
                  hasta que ésta devenga de dominio público.
                </li>
                <li>Honrar y cumplir con cualquier compromiso de inversión adquirido mediante la plataforma según el
                  funcionamiento descrito de ésta.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  6.-
                </span>
                Obligaciones de los usuarios emprendedores
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los usuarios emprendedores se obligan a:</p>

              <ul>
                <li>Guardar secreto y confidencialidad sobre la actividad de los usuarios inversores en la plataforma a
                  la que tengan acceso como resultado de su condición de usuario emprendedor en tanto dicha actividad no
                  devenga de dominio público.
                </li>
                <li>Obtener todas las autorizaciones y consentimientos que precisen para la presentación de sociedad
                  para recibir inversión y la formalización de acuerdos en nombre de éstas.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  7.-
                </span>
                Requisitos de los usuarios
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Para ostentar la condición de usuario y poder proceder al registro en TCA, deberán cumplirse los
                requisitos mínimos siguientes:</p>

              <ul>
                <li>Ser mayor de edad y tener plena capacidad de obrar, tanto el propio usuario como cualquier
                  representante persona física que deba actuar en representación de una entidad empleada por el usuario
                  para vehicular sus inversiones por medio de TCA.
                </li>
                <li>Disponer de documento de identidad oficial en España (DNI o NIE).</li>
                <li>Si el usuario representa a una persona jurídica, debe ostentar facultades suficientes para
                  representarla y firmar en su representación.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  8.-
                </span>
                Precio de los servicios
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El registro y creación de una cuenta por parte de los usuarios será totalmente gratuito. Ahora bien, en
                el caso de formalización de una operación de inversión, la remuneración que percibirá TCA estará
                compuesta por los siguientes conceptos:</p>

              <ul>
                <li>TCA devengará unos honorarios a cargo del emprendedor en concepto de estructuración y cierre de la
                  operación del 6% sobre el valor de la operación;
                </li>
                <li>TCA cobrará a la sociedad un porcentaje de la cantidad acreditada en el proceso de publicación según
                  se detalla a continuación:
                </li>

                <ul>
                  <li>3’5% por los inversores que provengan de un contacto generado directamente por el emprendedor o la
                    sociedad, siempre que (i) no se trate de inversores previamente registrados en la plataforma TCA y
                    que (ii) el emprendedor comunique la identidad del inversor a TCA con carácter previo a la
                    publicación de la inversión en la plataforma TCA.
                  </li>
                  <li>6% por el resto de los inversores.</li>
                </ul>

                <li>TCA devengará unos honorarios a cargo de la sociedad al emprendedor en concepto de prestación de
                  servicios de seguimiento de 4.000 € anuales (IVA no incluido), correspondiente a 1.000 euros por
                  trimestre y pagaderos a la finalización de cada trimestre.
                </li>
                <li>TCA devengará unos honorarios a cargo del inversor en concepto de corretaje, en el momento de la
                  inversión, equivalentes a un 2% sobre el capital invertido (IVA no incluido);
                </li>
                <li>TCA devengará unos honorarios en concepto de “carried interest” equivalente a un 10% (IVA no
                  incluido) sobre los beneficios obtenidos por el inversor, en el momento de la desinversión o de
                  obtención de liquidez de la inversión. Este “carried interest”el cual en ningún caso supondrá un coste
                  efectivo para la sociedad, será a cargo.
                </li>

                <ul>
                  <li>Directamente por el Inversor TCA, cuando el “carried interest” se devengue por una Transacción
                    Individual (tal y como se define a continuación);
                  </li>
                  <li>Por el inversor TCA, a través de la sociedad, actuando ésta en calidad de intermediaria, cuando el
                    “carried interest” se devengue por un acto distinto a una Transacción Individual.<br/><br/>A estos
                    efectos, se entenderá por Transacción Individual (i) toda transmisión, por cualquier título, de la
                    totalidad o parte de la participación del inversor TCA adquirida a través de la plataforma TCA en la
                    sociedad; y (ii) que se produzca individualmente por el inversor TCA o conjuntamente con otros
                    inversores pero que en su conjunto no supongan una transmisión superior al 50% del capital social de
                    la compañía.<br/><br/>En consecuencia, se entenderá por acto distinto a una Transacción Individual,
                    (i) toda transmisión, por cualquier título, de toda o parte de la participación del inversor TCA
                    adquirida a través de la plataforma TCA en la sociedad, que se produzca por el inversor TCA
                    conjuntamente con otros inversores y que en su conjunto suponga una transmisión superior al 50% del
                    capital social de la sociedad; y (ii) todo negocio jurídico (distinto a la transmisión de la
                    participación) que suponga la obtención de liquidez para el inversor TCA.
                  </li>
                </ul>

              </ul>

              <p>Como consecuencia de lo anterior, y dado que el “carried interest” está vinculado a los beneficios que
                obtienen los inversores TCA respecto a la sociedad, individualmente considerada, una vez que el inversor
                TCA haya obtenido por cualquier medio el retorno de su Inversión en la sociedad, deberá satisfacerse a
                TCA:</p>

              <ul>
                <li>En el supuesto de que el “carried interest” se devengue por una Transacción Individual, el inversor
                  TCA deberá satisfacer directamente a TCA una contraprestación equivalente a un 10% sobre cualesquiera
                  importes que obtengan por la titularidad o transmisión de su participación en la sociedad, más su
                  correspondiente IVA.
                </li>
                <li>En el supuesto de que el “carried interest” se devengue por un acto distinto a una Transacción
                  Individual, la sociedad, en tanto que figura intermediaria entre el inversor TCA y TCA, deberá
                  satisfacer a la plataforma la cantidad equivalente a un 10% sobre los beneficios obtenidos por el
                  inversor TCA más el correspondiente IVA.<br/><br/>En cualquier caso, la cantidad abonada por parte de
                  la sociedad a la plataforma será detraída o retenida de la cantidad total que deba percibir el
                  inversor TCA como consecuencia del acaecimiento de una Transacción no individual.
                </li>
              </ul>

              <p>A los efectos de lo previsto en los puntos anteriores, se hace constar que la rentabilidad de la
                inversión, y en consecuencia, el devengo de los honorarios a abonar a la plataforma en concepto de
                “carried interest”, tendrá lugar en los casos en que se produzca alguno de los acontecimientos que a
                modo enunciativo que no limitativo se indican a continuación: venta de las participaciones sociales que
                hubiera adquirido el inversor TCA en la sociedad a través de la plataforma (no contabilizando a tales
                efectos las transacciones que se produzcan sobre aquellas participaciones que, por ejemplo, hubiera
                adquirido el inversor TCA en compraventa o ampliaciones de capital no publicadas en la plataforma) ya
                sea a un tercero, a la propia sociedad (autocartera) o a otros inversores que acudan a rondas
                posteriores; reparto de dividendos y/o primas; distribución de reservas; reducción de capital por
                devolución de aportaciones; o venta de la sociedad.</p>

              <ul>
                <li>TCA devengará con cargo a la sociedad, una comisión de estructuración por la formalización de rondas
                  de inversión futuras a la inversión en la sociedad, y que irá en función de los siguientes parámetros:
                </li>
                <ul>
                  <li>(1) En el supuesto que, con carácter posterior a la formalización de la inversión, TCA desarrolle
                    una actividad consistente únicamente en el seguimiento del derecho de asunción preferente de los
                    inversores, así como en la intermediación entre la sociedad y los inversores, no se devengará
                    importe alguno en concepto de comisión de estructuración.
                  </li>
                  <li>(2) En el supuesto que, con carácter posterior a la formalización de la inversión, TCA gestione
                    una futura ronda de inversión en la sociedad, en la que participen los propios inversores y en la
                    que TCA deba negociar los términos y condiciones de la ronda con co-inversores, así como realizar
                    esfuerzos comerciales para captar financiación adicional, se devengará una comisión de
                    estructuración del 3% sobre el total de la inversión de los inversores en la futura ronda de
                    inversión.
                  </li>
                  <li>(3) En el supuesto que, con carácter posterior a la formalización de la inversión, TCA publique en
                    su plataforma una futura ronda de inversión en la sociedad, se devengará una comisión de
                    estructuración del 6% sobre el total de la inversión de la futura ronda de inversión publicada en la
                    plataforma TCA.<br/><br/>Se deja expresa constancia que la aplicación de lo dispuesto en el apartado
                    (3) anterior excluye expresamente la aplicación del apartado (2). En este caso, lo dispuesto en el
                    apartado (3) se aplicaría a la totalidad de la futura ronda de inversión publicada en la plataforma
                    TCA.<br/><br/>Las comisiones de estructuración previstas se establecen en contraprestación a los
                    servicios prestados por parte de TCA de asesoramiento a la sociedad en relación a la preparación de
                    las futuras rondas de inversión que pueda llevar a cabo, con independencia de que éstas se publiquen
                    o no en la plataforma TCA.
                  </li>
                </ul>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  9.-
                </span>
                Responsabilidad técnica, de la información y de las inversiones.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>El equipo de TCA analizará aquellas sociedades que presenten solicitudes de inversión y que cumplan los
                criterios de selección y condiciones establecidos en dicho proceso según el más leal saber y entender de
                su personal. Sin perjuicio de lo anterior, el usuario manifiesta conocer que TCA no otorga ninguna
                garantía y excluye a TCA de cualquier responsabilidad en relación a:</p>

              <ul>
                <li>la situación de las sociedades filtradas, ni de sus negocios y actividades pasadas, presentes,
                  prospectivas o futuras, ni de la capacidad de las compañías de efectivamente alcanzar sus planes
                  estratégicos, de desarrollo y de negocio;
                </li>
                <li>la veracidad, exactitud y precisión de las conclusiones extraídas de buena fe del proceso de
                  filtrado de las compañías ni de las conclusiones de revisión legal o financiera llevada a cabo, en su
                  caso, de las mencionadas compañías por TCA o por terceros por encargo de ésta;
                </li>
                <li>la posibilidad de los usuarios de efectivamente desinvertir cualquier inversión llevada a cabo
                  usando la plataforma de TCA ni el efectivo incremento de valor de las inversiones que lleven a cabo;
                </li>
                <li>la inexistencia de pasivos no contabilizados en los estados financieros de las sociedades filtradas
                  que puedan ser objeto de inversión;
                </li>
                <li>la inexistencia de cualquier error técnico que se pueda verificar en el uso de la plataforma en
                  cualquiera de sus funcionalidades o aplicaciones, especialmente en la formalización de muestras de
                  interés, compromisos de inversión, o la ejecución y formalización de inversiones, en este último caso,
                  siempre y cuando TCA haga sus mejores esfuerzos para corregir los defectos en el resultado producidos
                  por el error cuando algún dicho error llegue a su conocimiento;
                </li>
                <li>la adecuada, exacta y correcta intervención de terceros necesarios para el proceso, pero ajenos a
                  TCA en los procesos de formalización y ejecución de las operaciones, tales como entidades financieras,
                  la sociedad objetivo, fedatarios públicos, registradores mercantiles u otros profesionales;
                </li>
                <li>cualquier daño derivado del uso de la plataforma.</li>
              </ul>

              <p>Asimismo, el usuario manifiesta comprender que:</p>

              <ul>
                <li>existe un elevado grado de probabilidad y riesgo de que un porcentaje significativo de las
                  sociedades filtradas puedan no poder acometer sus planes de negocio por falta de recursos financieros
                  o la incapacidad de realizar los ingresos esperados de sus actividades proyectadas.
                </li>
                <li>es de su exclusiva responsabilidad llevar a cabo cualquier acto tendente a recibir asesoramiento de
                  cualquier naturaleza que considere conveniente para tomar decisiones en relación a la ejecución de
                  inversiones o desinversiones en sociedades a través de la plataforma.
                </li>
                <li>las actividades de TCA y las informaciones ofrecidas en el sitio web y en la plataforma de TCA no
                  constituyen asesoramiento financiero ni actividades de servicios de inversión, ni deberán entenderse
                  como recomendaciones de TCA para llevar a cabo inversiones, incluso en el caso que TCA participe
                  directa o indirectamente en las inversiones que se lleven a cabo por parte de los usuarios, debiendo
                  cada usuario formar sus propios juicios independientes y adoptar sus propias decisiones en relación a
                  su actividad de inversión en uso de la plataforma de TCA.
                </li>
                <li>en ningún caso responderá TCA por ninguna acción o decisión que el usuario lleve a cabo o adopte
                  basada en todo o en parte en datos o informaciones facilitadas por TCA en su plataforma.
                </li>
                <li>los datos o información que aparezcan en los apartados no públicos del sitio web de TCA son
                  propiedad de ésta y el usuario no tiene permiso para retransmitir, redistribuir, publicar, mostrar o
                  revelar ni la totalidad ni ninguna parte de dichos datos o informaciones a terceras personas. Se
                  exceptúa el caso de existencia de obligación legal de proceder a su revelación o comunicación, en cuyo
                  caso podrá ser revelada en la medida en que esto sea legalmente exigible, debiendo en todo caso
                  notificar dicha comunicación o revelación a TCA con la mayor antelación posible.
                </li>
              </ul>

              <p>En todo caso, TCA no responderá de cualquier pérdida materializada como resultado de una inversión, una
                sugerencia o consejo, operación frustrada ni, en general, de los actos u omisiones de terceros,
                especialmente del incumplimiento de promesas u obligaciones por parte de terceros, incluso si han sido
                presentados o contratados por TCA.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <a id="riesgos"/>
                <span className="f-s-24 num">
                  10.-
                </span>
                Riesgos
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>En TCA publicamos operaciones empresariales de “Startups” o empresas de reciente creación, que buscan
                financiación, lo que conlleva una serie de riesgos como pueden ser la falta de liquidez, la ausencia de
                dividendos, pérdida de la inversión, el riesgo de dilución de la participación en la sociedad, la no
                posibilidad de influir en la gestión de la sociedad o la no transmisibilidad de las participaciones. Es
                por ello que se recomienda invertir una cantidad que se esté dispuesto a perder ya que TCA no le
                reintegrará la inversión realizada.</p>

              <h4>Riesgo de falta de liquidez y transmisibilidad</h4>

              <p>La liquidez evalúa la facilidad que tiene un activo en convertirse en dinero, y en este caso en
                concreto sería la facilidad con que se pueden vender las participaciones de una “Startup” después de
                adquirirlas. Como las participaciones de una “Startup” no cotizan, la posibilidad de transmitir las
                participaciones es baja o muy baja, lo que supone que la inversión deba considerarse como una inversión
                a medio plazo, y de escasa liquidez.</p>

              <h4>Ausencia de dividendos</h4>

              <p>Los dividendos son pagos que efectúa una empresa a sus socios, resultado de los beneficios obtenidos
                por la misma.</p>

              <p>Como TCA trabaja con “Startups” o empresas de reciente creación, es poco probable que vayan a
                distribuir dividendos durante los primeros años, pues su principal objetivo no es otra más que
                capitalizar la empresa para facilitar su crecimiento, generando así un valor futuro para sus socios.</p>

              <h4>Riesgo de pérdida total o parcial de la inversión</h4>

              <p>Las inversiones en “Startups” o empresas de reciente creación, como sabemos, tienen un alto grado de
                riesgo e incertidumbre, ya que tienen que enfrentarse a riesgos operativos y financieros especialmente
                significativos. Así, a pesar de que los rendimientos esperados de las inversiones en este tipo de
                sociedades son elevados, el inversor debe ser consciente de que los referidos retornos pueden ser
                escasos o incluso no producirse nunca. Por ello, y dado el alto riesgo asumido, la pérdida total del
                capital invertido puede ocurrir.</p>

              <h4>Riesgo de dilución</h4>

              <p>Se advierte a los inversores que cualquier inversión realizada a través de la plataforma puede estar
                sujeta a una posible dilución futura. Se produce dilución cuando una empresa crea nuevas
                participaciones, y los socios que no suscriben las nuevas participaciones emitidas, ven reducida su
                participación en la empresa de forma proporcional a la ampliación de capital realizada, conllevando una
                pérdida o minoración de derechos de voto, de dividendos o del valor de la participación.</p>

              <h4>Riesgo de no poder influir en la gestión de la sociedad</h4>

              <p>Los inversores minoritarios tienen una capacidad limitada a la hora de influir en la gestión de las
                sociedades en las que hayan invertido. No obstante, los inversores TCA, tal como se ha indicado
                anteriormente, una vez que hayan adquirido sus participaciones en la sociedad objeto de inversión,
                sindicaran (unirán) sus participaciones con las de otro inversores minoritarios, con el fin de aumentar
                su representación en la sociedad. </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  11.-
                </span>
                Medidas adoptadas para evitar el riesgo de fraude y el riesgo operacional.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>TCA dispone de las medidas y medios organizativos necesarios para minimizar el riesgo de fraude y el
                riesgo operacional, entre ellas:</p>

              <ul>
                <li>TCA recopila toda la información necesaria para la correcta identificación de los usuarios de la
                  plataforma, y en especial, de aquellos usuarios emprendedores que tengan la intención de publicar su
                  operación en la plataforma con la finalidad de obtener financiación por parte de los usuarios
                  inversores, mediante la realización, a través de un tercero, de un informe de Due Diligence, en el
                  cual se analiza con detalle toda la información legal, económico-financiera y laboral.
                </li>
                <li>TCA lleva a cabo reuniones internas de seguimiento con los responsables de cada área, a los efectos
                  de poder llevar un control del correcto funcionamiento de la plataforma, así como de verificar el
                  cumplimiento del Reglamento Interno de Conducta.
                </li>
                <li>TCA realiza, igualmente, un seguimiento continuo de las operaciones publicadas en la plataforma, des
                  del momento de publicación de las mismas hasta la posterior formalización de la inversión, así como
                  con posterioridad a la misma.
                </li>
                <li>En TCA, todas las transacciones (cobros y pagos) se realizan a realizan a través de un intermediario
                  externo, autorizado por el Banco de España, que asume el compromiso de velar porque el sistema de
                  pagos y cobros se realice de forma adecuada y sin riesgos de fraude y de incorrecto funcionamiento de
                  sistema.
                </li>
                <li>Toda la operativa de la plataforma cuenta con los estándares más elevados de seguridad online,
                  mediante un certificado digital emitido por DigiCert Inc, que cuenta con el algoritmo de seguridad:
                  SHA-256 con encriptación RSA (1.2.840.113549.1.1.11 ) y el tamaño de la clave es de 2.048 bits.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  12.-
                </span>
                Operaciones vinculadas y conflictos de interés.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Los artículos 32 y 63 de la Ley 5/2015, de 27 de abril, de Fomento de la Financiación Empresarial y el
                Reglamento Interno de Conducta de TCA, regulan los conflictos de interés y operaciones vinculadas. En
                atención a la referida normativa, las Plataformas de Financiación Participativa (en adelante, las
                “PFP”), así como sus administradores, altos ejecutivos y socios que ostenten un porcentaje superior al
                10% del capital social de la PFP, no pueden invertir más de un 10% del objetivo de financiación de cada
                operación, ni que su inversión les permita controlar la empresa, en los términos previstos en el
                artículo 42 del Código de Comercio.</p>

              <p>TCA dispone de mecanismos y procedimientos para evaluar las operaciones que puedan ser objeto de
                publicación en su sitio web, a los efectos de detectar cualquier potencial conflicto de interés o
                operación vinculada.</p>

              <p>Existe un Responsable de Compliance y un Comité de Análisis de Operaciones Vinculadas encargados de
                analizar y valorar la existencia de elementos que pueda conllevar la calificación de una operación como
                vinculado o un eventual conflicto de interés, y validar únicamente aquéllos que cumplan con lo dispuesto
                en la Ley 5/2015 y el Reglamento Interno de Conducta de TCA.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  13.-
                </span>
                Mecanismos y procedimiento de actuación previstos en caso de cese de la actividad de TCA.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>En caso de cese de la actividad de la Plataforma de Financiación Participativa TCA, se activarán una
                serie de mecanismos para que se sigan prestando todos o parte de los servicios a los que se comprometió
                frente a las operaciones de financiación participativa que hubieran obtenido financiación, que son los
                siguientes:</p>

              <p>1.- En cuanto a la gestión y distribución de la inversión, TCA se compromete a intentar buscar otra
                Plataforma de Financiación Participativa a la que poder ceder la actividad de TCA para que las
                operaciones puedan continuar realizándose hasta que se cierre la operación.</p>

              <p>2.- En cuanto a la prestación de servicios de apoyo y seguimiento de la potencial inversión realizada
                por TCA a sus clientes emprendedores, TCA se compromete a intentar buscar otra Plataforma de
                Financiación Participativa que ofrezca dichos servicios.</p>

              <p>3.- En el caso de que TCA ceda la actividad a otra Plataforma de Financiación Participativa, TCA se
                compromete a entregar toda la documentación e información dónde se encuentren los datos de los
                inversores, constando todas sus inversiones, para que la nueva Plataforma de Financiación Participativa
                pueda continuar con la operación y tengan en cuenta los inversores que ya han aportado dinero.</p>

              <p>La falta de activación de dichos mecanismos conllevará las siguientes consecuencias que para los
                inversores y promotores:</p>

              <ul>
                <li>La participación de los inversores en las operaciones subsistirá, y los inversores seguirán siendo
                  accionistas de ella. TCA se compromete a notificar a cada inversor el estado de sus inversiones en
                  cada una de las operaciones, indicando cuánto dinero ha invertido en cada sociedad, el número de
                  participaciones sociales que ostenta, el valor de las mismas y el domicilio de cada sociedad.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  14.-
                </span>
                Reglamento Interno de Conducta.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>En cumplimiento de lo dispuesto en el apartado h) del artículo 55 de la Ley 5/2015, de 27 de abril, de
                Fomento de la Financiación Empresarial, TCA dispone de un Reglamento Interno de Conducta.</p>

              <p>Sin perjuicio de cualesquiera otras obligaciones que resulten exigibles en virtud de la normativa
                aplicable y de sus estatutos sociales, el Reglamento Interno de Conducta determina los criterios de
                comportamiento y actuación que deben seguir sus destinatarios en relación con los conflictos de interés,
                la información confidencial y los términos de la participación de los administradores, directivos,
                empleados y apoderados de TCA en las operaciones de financiación que se instrumenten a través de la
                plataforma.</p>

              <ul>
                <li><strong>Ámbito subjetivo de aplicación.</strong> El Reglamento Interno de Conducta se aplica a todos
                  los empleados, directivos, apoderados y a los miembros del Consejo de Administración de TCA.
                </li>
                <li><strong>Ámbito objetivo de aplicación.</strong> Quedan comprendidos dentro del ámbito objetivo del
                  Reglamento Interno de Conducta las operaciones subidas a la plataforma para su financiación, tanto
                  aquéllos que hayan sido seleccionados y publicados, como aquéllos cuya publicación haya sido
                  descartada, independientemente del motivo.
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  15.-
                </span>
                Datos de los auditores de TCA.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Todas las Plataformas de Financiación Participativa registradas en la CNMV están obligadas a auditarse,
                por ello TCA cuenta con los servicios de la empresa de auditoría BDO Auditores y Consultores, S.L.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  16.-
                </span>
                Procedimientos y medios para la presentación de quejas y reclamaciones.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Cualquier usuario de la plataforma, ya sea usuario inversor o usuario emprendedor, podrá realizar
                cualesquiera quejas y/o reclamaciones sobre la plataforma a través del siguiente procedimiento,
                habilitado específicamente para la presentación, tramitación y resolución de dichas quejas y/o
                reclamaciones.</p>

              <h4>A. Procedimiento de presentación de quejas y/o reclamaciones.</h4>

              <p>La plataforma ofrece a sus usuarios registrados la posibilidad de formular y presentar quejas y/o
                reclamaciones sobre el contenido y funcionamiento de la plataforma. A estos efectos, se entenderá
                por:</p>

              <ul>
                <li>Quejas: cualesquiera opiniones referidas a tardanzas, desatenciones o cualquier otro tipo de
                  deficiencia relativos al funcionamiento de los servicios de la plataforma.
                </li>
                <li>Reclamaciones: cualesquiera manifestaciones que pongan de manifiesto hechos concretos referidos a
                  acciones u omisiones que supongan un presunto incumplimiento de los servicios ofrecidos en la
                  plataforma o de los compromisos u obligaciones de la plataforma, que impliquen para el usuario que las
                  formula un perjuicio para sus intereses y derechos, con la pretensión de obtener una restitución.
                </li>
              </ul>

              <p>En cuanto a la presentación de quejas y/o reclamaciones, se seguirá el siguiente procedimiento:</p>

              <p>Los usuarios tienen dos sistemas para presentar la queja o reclamación:</p>

              <ul>
                <li>Enviando un email al correo electrónico support@thecrowdangel.com, que deberá incluir al menos la
                  siguiente información:
                </li>
                <ul>
                  <li>Identificación del usuario, haciendo constar el nombre y apellidos o, en caso de persona jurídica,
                    la razón social;
                  </li>
                  <li>Dirección de correo electrónico;</li>
                  <li>Y explicación de la queja o reclamación, indicando, todos aquellos datos que permitan identificar
                    los hechos en que se fundamenta la queja o reclamación.
                  </li>
                </ul>
                <li>En el apartado “contactar”, presente en todas las páginas de la web tanto si estás registrado como
                  si no.
                </li>
              </ul>

              <h4>B. Procedimiento de resolución de quejas y/o reclamaciones.</h4>

              <p>Recibida la queja o reclamación, se acusará recibo de su recepción al usuario que la hubiera
                presentado, indicándole que se inicia el procedimiento para su resolución. Se procederá a la apertura de
                un expediente que se resolverá con la mayor brevedad posible, sin superar el plazo de 2 meses, a contar
                desde la fecha en que la queja o reclamación hubiera sido presentada. Los usuarios podrán aportar
                cualesquiera documentos justificativos que sustenten su queja o reclamación.</p>

              <p>Las quejas o reclamaciones presentadas por los usuarios inversores, serán tramitadas y resueltas por el
                Responsable de Negocio.</p>

              <p>Las quejas o reclamaciones presentadas por los usuarios emprendedores, serán tramitadas y resueltas por
                el Responsable de Operaciones.</p>

              <p>El responsable encargado de la tramitación de la queja o reclamación deberá recibir de empleados,
                apoderados, directivos y miembros del órgano de administración, el apoyo necesario para obtener
                información que obre en poder o esté a disposición de TCA sobre la queja o reclamación.</p>

              <p>Una vez resuelta, se le notificará al usuario a la dirección de correo electrónico comunicada al inicio
                del expediente, el contenido de la decisión adoptada, que deberá ser motivada.</p>

              <p>Excepcionalmente, en atención a las circunstancias concretas de una queja o reclamación, podrá el
                responsable encargado de su tramitación elevar su resolución a decisión del Consejo de Administración de
                TCA.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span className="f-s-24 num">
                  17.-
                </span>
                Comunicaciones y privacidad.
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 padding-left-60">
              <p>Las declaraciones hechas en los foros, tablones de anuncios, chats y otros servicios de comunicación
                sólo reflejan las opiniones de sus autores. TCA no será responsable por el contenido o la forma de las
                comunicaciones, manifestaciones y opiniones vertidas por los usuarios empleando la plataforma ni de
                cualquier acción que derive de la participación en cualquiera de ellos. Los moderadores y anfitriones de
                los foros no son representantes autorizados de TCA, y sus puntos de vista no reflejan aquellos de TCA.
                El usuario reconoce y acepta que sus comunicaciones con otros usuarios a través de los medios dispuestos
                en la plataforma al efecto son públicas y no privadas, y que no tiene expectativa de privacidad respecto
                al hacer uso de estos servicios.</p>

              <p>El usuario reconoce que la información personal que el usuario comunique en los medios dispuestos al
                efecto puede ser vista y utilizada por otras personas y dar lugar a comunicaciones no solicitadas. TCA
                se reserva el derecho a revelar cualquier contenido que se encuentre publicado en la plataforma con la
                finalidad de dar cumplimiento a cuantas leyes, reglamentos, procesos legales o solicitudes
                gubernamentales pudieran ser aplicables.</p>

              <p>Cuando un usuario decida seguir a una compañía (seleccionando el apartado “Me interesa”) o invertir en
                una sociedad (seleccionando el apartado “Invertir”), esta elección será visible por parte de todos los
                usuarios. Sin perjuicio de lo anterior, se podrá configurar, en el apartado “Mi perfil”, la visibilidad
                para terceros de la efectiva ejecución de la inversión, a la libre discreción de cada usuario.</p>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

export default CustomerInformationComponent;



// WEBPACK FOOTER //
// ./src/modules/customer-information/CustomerInformation.component.tsx